import React, { useCallback } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { UnknownObject } from '../../../../../../react-app-env';

import { TextField } from '@mui/material';

import { Questionnaire, ValidationErrors, QuestionnaireReducerAction, validation } from '../..';

import styles from './styles';

interface Props extends WithStyles<typeof styles> {
  classes: ClassNameMap<string>;
  questionnaire: Questionnaire;
  errors: ValidationErrors;
  setErrors: React.Dispatch<React.SetStateAction<ValidationErrors>>;
  dispatch: React.Dispatch<{ type: QuestionnaireReducerAction; value: any }>;
}

const StepDetails = ({ classes, questionnaire, errors, setErrors, dispatch }: Props): React.ReactElement => {
  const validate = useCallback(
    (field: string) => {
      const errorItems: UnknownObject = {};
      if (field === 'name') {
        errorItems.name = validation.name(questionnaire.name);
      }

      setErrors({ ...errors, ...errorItems });
    },
    [questionnaire, errors, setErrors]
  );

  return (
    <>
      <div className={classes.root}>
        <TextField
          className={classes.textField}
          data-qa="name-textfield"
          required
          label="Name"
          variant="outlined"
          error={errors.name as boolean}
          helperText={errors.name}
          value={questionnaire.name}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => dispatch({ type: QuestionnaireReducerAction.NAME, value: event.target.value })}
          onKeyUp={() => validate('name')}
          onBlur={() => validate('name')}
        />
      </div>
    </>
  );
};

export default withStyles(styles)(StepDetails);
